'use strict';

angular
  .module('ClinicApp')
  .factory('SentimentService', function(SentimentResource) {
    return {
      getClinicSentimentData: function(clinicId) {
        return SentimentResource.get({
          clinicId: clinicId,
        }).$promise;
      },

      createNewClinicSentiment: function(clinicId, data) {
        return SentimentResource.save({
          clinicId: clinicId,
        }, data).$promise;
      },
    };
  });
